// src/utils/api.js

import axios from 'axios';
const {REACT_APP_STAGE: STAGE, REACT_APP_PDF_SCRAPER_URL: PDF_SCRAPE_URL} = process.env;

const scrapePdf = async (pdfUrl, sessionId) => {
  try {
    const response = await axios.post(`${PDF_SCRAPE_URL}/${STAGE}/mediaferry/scrapePdf`, {
      pdfUrl,
      sessionId,
    });

    return response.data;
  } catch (error) {
    console.error('Error scraping PDF:', error);
    throw error;
  }
};

export {scrapePdf};
